import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { HashRouter } from "react-router-dom";
import App from "App";

// Material Dashboard 2 React Context Provider
import { MaterialUIControllerProvider } from "context";
import { AuthContextProvider } from "context/auth-context";

const container = document.getElementById("app");
const root = createRoot(container);

const role = localStorage.getItem("role");

if (role?.trim()) {
  document.title = role;
}

root.render(
  <HashRouter>
    <MaterialUIControllerProvider>
      <AuthContextProvider>
        <App />
      </AuthContextProvider>
    </MaterialUIControllerProvider>
  </HashRouter>
);
